import type { FC, ReactElement, ReactNode } from 'react';
import { Fragment } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';
import { Text } from '../../text/Text';

import styles from './popupContent.module.css';

interface BlockingModalContentPropsBase {
  actions?: ReactElement[];
  inCurtain?: boolean;
  title?: ReactNode;
  children?: ReactNode;
}

export type BlockingModalContentProps = BlockingModalContentPropsBase;

export const BlockingModalContent: FC<BlockingModalContentProps> = ({
  actions,
  children,
  inCurtain,
  title,
}): ReactElement => {
  const mods = useModifiers(
    styles,
    'popupContent',
    {
      inCurtain,
    },
    { withBaseClass: true }
  );

  return (
    <div data-testid="blocking-popup-content" className={mods}>
      {title ? (
        <div data-testid="blocking-popup-title" className={styles.popupContent__title}>
          {title}
        </div>
      ) : null}
      <Text className={styles.popupContent__message}>{children}</Text>
      {actions?.length ? (
        <div data-testid="blocking-popup-buttons" className={styles.popupContent__buttons}>
          {actions.map((action, index) => (
            <Fragment key={index}>{action}</Fragment>
          ))}
        </div>
      ) : null}
    </div>
  );
};
